import React from 'react';
import {
  ComponentLevelNotification,
  Input,
  Label,
} from '@americanexpress/dls-react';
import { useIntl } from 'react-intl';

export function FormField(props) {
  const intl = useIntl();
  const optionalLabel = props?.field?.must === false ? `${intl.formatMessage({ id: 'enroll.form.optional-label', defaultMessage: ' (optional)' })}` : '';

  return (
    <div className="margin-t">
      <Label id={`${props?.id}+ 'label'`} for={props?.id}>
        {`${props?.field?.label}${optionalLabel}`}
      </Label>
      <section className="pad-2-b">
        {props?.autofilled
          ? props?.autofilled
          : (
            <>
              <Input
                id={props?.id}
                name={props?.id}
                value={props?.value}
                type={props?.field?.type}
                disabled={props?.disabled}
                minLength={props?.field?.minLength}
                maxLength={props?.field?.maxLength}
                onChange={props?.onChange}
                success={props?.success}
                status={props?.status}
                required={props?.field?.must}
                aria-required={props?.field?.must}
              />
              {props?.inputWarning && (
              <ComponentLevelNotification className="pad-1-t">
                {props?.inputWarning}
              </ComponentLevelNotification>
              )}
            </>
          )}
      </section>
    </div>
  );
}
